const ServiceStatusTypeEnum = {
  VehicleAccepted : 1,
  InProcess : 2,
  AwaitingParts : 3,
  BeingTested : 4,
  ReadyforDelivery : 5,
  Delivered : 6,
  NotProcess : 7
}
export default ServiceStatusTypeEnum;
